//  Array of healthy snack choices

const healthyArray = [
  { snackName: "apple", sugarContent: 11.33 },
  { snackName: "carrot", sugarContent: 1.59 },
  { snackName: "croissant", sugarContent: 7.54 },
  { snackName: "tomato sandwich", sugarContent: 5 },
  { snackName: "peanut butter celery", sugarContent: 3.23 },
  { snackName: "garden salad", sugarContent: 8.21 },
  { snackName: "rice cakes", sugarContent: 0.08 },
  { snackName: "apple sauce", sugarContent: 16.28 },
  { snackName: "mixed vegetables", sugarContent: 3.66 },
  { snackName: "yogurt", sugarContent: 11.97 },
  { snackName: "granola bar", sugarContent: 8.1 },
  { snackName: "grapes", sugarContent: 7.59 },
  { snackName: "dark chocolate almonds", sugarContent: 0.14 },
  { snackName: "pretzels", sugarContent: 0.63 },
  { snackName: "bagel", sugarContent: 8.85 },
  { snackName: "cheese and crackers", sugarContent: 2.25 },
  { snackName: "cucumber sandwich", sugarContent: 3.13 },
  { snackName: "hummus and pita", sugarContent: 0.78 },
  { snackName: "peaches", sugarContent: 14.68 },
  { snackName: "banana", sugarContent: 14.43 },
  { snackName: "smoothie", sugarContent: 23.8 },
  { snackName: "hard-boiled egg", sugarContent: 0.56 },
  { snackName: "trail mix", sugarContent: 17.43 },
  { snackName: "chips and salsa", sugarContent: 3.04 },
  { snackName: "english muffin", sugarContent: 0 },
  { snackName: "chips and guacamole", sugarContent: 0.76 },
  { snackName: "orange", sugarContent: 1.45 },
  { snackName: "sweet potato chips", sugarContent: 2.5 },
  { snackName: "watermelon", sugarContent: 17.73 },
  { snackName: "avocado toast", sugarContent: 1.81 },
];

export default healthyArray;
